<template>
    <div id="benefits">
        <!--=====================================-->
        <!--=       Why Choose Area Start       =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-12 ">
                        <div class="section-heading">
                            <span class="subtitle primary">Soluciones</span>
                            <h2 class="font-weight-100">¿Qué <span class="bold">créditos</span> ofrecemos?</h2>
                        </div>
                    </div>
                    <!-- PRODUCTOS -->
                    <div class="row mb--100">
                        <div class="col-lg-6">
                            <div class="why-choose-us">
                                <div class="section-heading heading-left mb-0">
                                    <h3 class="font-weight-100">Crédito <span class="bold">Productos.</span></h3>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-8 col-lg-8">
                                            <p class="body-font1">Queremos colaborar con el crecimiento de nuestros
                                                instaladores fortaleciendo su oferta.</p>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <button @click.stop="goToPage('forProductsPage')"
                                                class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button-black w-auto btn-p">Conoce
                                                más</button>
                                        </div>
                                    </div>

                                </div>
                                <div class="accordion" id="choose-accordion">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                <span class="icon rayo"></span> Usos
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show"
                                            aria-labelledby="headingOne" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Este financiamiento hace posible que tus clientes 
                                                tengan acceso a la energía limpia.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                                                aria-controls="collapseTwo">
                                                <span class="icon sun"></span>Tecnologías
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse"
                                            aria-labelledby="headingTwo" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Paneles solares, Calentadores solares, Enfriamiento eficiente (refrigeradores, vitrinas y aire acondicionado), Iluminación eficiente (luminarias LED).
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree">
                                                <span class="icon money"></span>Montos
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse"
                                            aria-labelledby="headingThree" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Montos a financiar desde $50,000 hasta $10,000,000.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                aria-expanded="false" aria-controls="collapseFour">
                                                <span class="icon face"></span>Beneficios
                                            </button>
                                        </h2>
                                        <div id="collapseFour" class="accordion-collapse collapse"
                                            aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                <ul class="">
                                                    <li>Ofrece 0% enganche.</li>
                                                    <li>Plan de pagos que permite a tu cliente pagar muy poco mientras se refleja su ahorro en el recibo de luz.</li>
                                                    <li>Con requisitos que se adaptan al perfil de tu cliente y te permiten llegar a más.</li>
                                                    <li>Abonos a capital o liquidación sin penalización</li>
                                                    <li>Recibe directamente el 70% de anticipo para comenzar a instalar, no te descapitalices.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                aria-expanded="false" aria-controls="collapseFive">
                                                <span class="icon tool"></span>Herramientas
                                            </button>
                                        </h2>
                                        <div id="collapseFive" class="accordion-collapse collapse"
                                            aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Tenemos una plataforma de instaladores para simular, solicitar y dar seguimiento a los créditos de tus clientes sin papeleo..
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-6 offset-xl-1 mt--20 mb-5">
                            <div class="why-choose-us mb--30">
                                <div class="why-choose-thumb">
                                    <img :src="`${imgBase}instalador-product.png`"
                                        alt="Office">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- PRODUCTOS -->


                    <!-- NEGOCIOS -->
                    <div class="row">
                        <div class="col-xl-5 col-lg-6 mt--20 ">
                            <div class="why-choose-us mb--30">
                                <div class="why-choose-thumb">
                                    <img :src="`${imgBase}instalador-business.png`"
                                        alt="Office">
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 offset-xl-1">
                            <div class="why-choose-us">
                                <div class="section-heading heading-left mb-0">
                                    <h3 class="font-weight-100">Crédito <span class="bold">Negocios.</span></h3>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-8 col-lg-8">
                                            <p class="body-font1">Recibe capital de trabajo para utilizarlo en lo que hará crecer tu negocio.</p>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <button @click.stop="goToPage('forBusinessPage')"
                                                class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button-black w-auto btn-p">Conoce
                                                más</button>
                                        </div>
                                    </div>

                                </div>
                                <div class="accordion" id="choose-accordion">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseUse" aria-expanded="true"
                                                aria-controls="collapseUse">
                                                <span class="icon add"></span> Usos
                                            </button>
                                        </h2>
                                        <div id="collapseUse" class="accordion-collapse collapse show"
                                            aria-labelledby="headingOne" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                El financiamiento que te permite capitalizarte para desarrollar proyectos, fortalecer la infraestructura de tu empresa, crédito puente o lo que necesite tu negocio.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseBusiness" aria-expanded="false"
                                                aria-controls="collapseBusiness">
                                                <span class="icon sun"></span>Giros
                                            </button>
                                        </h2>
                                        <div id="collapseBusiness" class="accordion-collapse collapse"
                                            aria-labelledby="headingTwo" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Integradores solares, Desarrollador de proyectos eficientes, Distribuidor de productos solares o eficientes, Fabricante de productos solares o eficientes.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseAmount"
                                                aria-expanded="false" aria-controls="collapseAmount">
                                                <span class="icon money"></span>Montos
                                            </button>
                                        </h2>
                                        <div id="collapseAmount" class="accordion-collapse collapse"
                                            aria-labelledby="headingThree" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Montos a financiar desde $50,000 hasta $10,000,000.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseBenefit"
                                                aria-expanded="false" aria-controls="collapseBenefit">
                                                <span class="icon face"></span>Beneficios
                                            </button>
                                        </h2>
                                        <div id="collapseBenefit" class="accordion-collapse collapse"
                                            aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                <ul>
                                                    <li>Sin enganche, recibe el monto que solicites íntegro en tu cuenta.</li>
                                                    <li>Tienes la posibilidad de pagar solo intereses en tus mensualidades y liquidar el créditos al fianl del plazo.</li>
                                                    <li>Con tu cuenta de instalador RedGirasol verificada ¡tu créditos está pre-aprobado!</li>
                                                    <li>Abonos a capital o liquidación sin penalización.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTools"
                                                aria-expanded="false" aria-controls="collapseTools">
                                                <span class="icon tool"></span>Herramientas
                                            </button>
                                        </h2>
                                        <div id="collapseTools" class="accordion-collapse collapse"
                                            aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Simula y solicita un crédito para tu negocio desde la plataforma de instaladores.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- NEGOCIOS -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "Benefits",
    components: {
    },
    data() {
        return {
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/fotografias/suppliers/foto-"
        }
    }
}

</script>

<style scoped>
.container {
    padding: 3rem;

}

.icon {
    height: 20px;
    width: 20px;
    display: block;
    background-size: 20px !important;
    background-repeat: no-repeat !important;
    margin-right: 10px;
}

.sun {
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-sun.png");
}

.tool {
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-tool.png");
}

.face {
    background-position-y: center !important;
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-face.png");
}

.money {
    background-size: 15px !important;
    background-position-x: center !important;
    background-position-y: center !important;
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-money.png");
}
.rayo {
    background-position-y: center !important;
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-rayo.png");
}
.add {
    background-position-y: center !important;
    background: url("https://cdn.redgirasol.com/nuevo_portal/icons/suppliers/icon-instalador-add.png");
}

.btn-p {
    padding: 1.5rem 2rem 1.5rem 2rem;
}</style>